export function keypointsOfPoses(poses) {
    let keypoints = [];

    for (let pose of poses){
        pose.score > 0.2 && (keypoints.push(...pose.keypoints));
    }

    return keypoints;
}